import { useLocation } from 'react-router-dom'
import { getUserMenuByDate } from 'src/redux-api-bridge/menu/effects'
import { useDispatch } from 'react-redux'

export function useMenuRefetch() {
  const location = useLocation()
  const dispatch = useDispatch()

  const getDateFromUrl = (): string | undefined => {
    const params = new URLSearchParams(location.search)
    const date = params.get('date')
    return date || undefined
  }

  const refetchMenu = () => {
    const date = getDateFromUrl()
    if (!date) return

    dispatch(getUserMenuByDate(date, false, false))
  }

  return { refetchMenu }
}
